export const SportOfferFeatureFlag = {
    CombinableMarketGroup: 'sports-offer.combinable-market-group-filter-enabled',
    SuperBonusForAnySelectionCount: 'pbp.super-bonus-for-any-selection-count',
    SuperAdvantagePage: 'pbp.generosity.is-super-advantage-page-enabled',
    PerLegSettlementStatus: 'sports-offer.per-leg-settlement-enabled',
} as const;
export type SportOfferFeatureFlag = typeof SportOfferFeatureFlag[keyof typeof SportOfferFeatureFlag];
